import * as React from 'react';
import { IProduct,IQuantity} from '../../functions/Interfaces';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';


class Review extends React.Component<{products: IProduct[];quantity: IQuantity[];}> {
  
  public getTotalAmount(products: IProduct[], quantity: IQuantity[]): number {
    let totalAmount: number = 0;
    products.forEach((product: IProduct) => {
      const dummyQuantity: any = quantity.find(item => item.id === product.id);
      let elemQuantity: IQuantity = { id: "0", quantity: 0 };
      if (dummyQuantity !== undefined) {
        elemQuantity = dummyQuantity;
      }
      const price: number = elemQuantity.quantity * product.price;
      totalAmount = totalAmount + price;
    });
    return totalAmount;
  }

  public render() {
    const products: IProduct[] = this.props.products;
    const quantity: IQuantity[] = this.props.quantity;
    const totalAmount: number = this.getTotalAmount(products, quantity);

    return (
      <div>
        <React.Fragment>
          <Typography variant="h6" gutterBottom={true}>
            Order summary
          </Typography>
          <List disablePadding={true}>
            {products.map(product => {
              let elemQuantity: IQuantity = { id: "0", quantity: 0 };
              const dummyQuantity: any = quantity.find(
                item => item.id === product.id
              );
              if (dummyQuantity !== undefined) {
                elemQuantity = dummyQuantity;
              }
              return (
                <ListItem className="ListItem" key={product.name}>
                  <ListItemText
                    primary={product.name}
                    secondary={product.category[0]}
                  />
                  <ListItemText primary={elemQuantity.quantity + " x "} />
                  <ListItemText primary={product.price + " €"} />
                  <Typography variant="body2">
                    {product.price * elemQuantity.quantity + " €"}{" "}
                  </Typography>
                </ListItem>
              );
            })}
            <ListItem className="ListItem">
              <ListItemText primary="Total" />
              <Typography variant="subtitle1" className="TotalAmount">
                {totalAmount + " €"}
              </Typography>
            </ListItem>
          </List>
        </React.Fragment>
      </div>
    );
  }
}
export default Review;


// WEBPACK FOOTER //
// ./src/components/checkout/Review.tsx